import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/auth")({
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<"signin" | "signup">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate({ to: "/admin" });
    });
  }, [navigate]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setInfo(null);
    setLoading(true);
    try {
      if (mode === "signup") {
        const { error } = await supabase.auth.signUp({
          email,
          password,
          options: { emailRedirectTo: `${window.location.origin}/admin` },
        });
        if (error) throw error;
        setInfo("Account erstellt. Du kannst dich jetzt einloggen.");
        setMode("signin");
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        navigate({ to: "/admin" });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ maxWidth: 400, margin: "4rem auto", padding: "2rem", background: "var(--bg-surface)", borderRadius: "var(--radius-sm)", border: "1px solid var(--border-purple)" }}>
      <h1 style={{ color: "var(--accent-cyan)", marginBottom: "1.5rem" }}>
        {mode === "signin" ? "Login" : "Sign Up"}
      </h1>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <label style={{ display: "flex", flexDirection: "column", gap: "0.25rem", color: "var(--text-muted)", fontSize: "0.85rem" }}>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            style={{ padding: "0.5rem 0.75rem", background: "var(--bg-primary)", color: "var(--text-primary)", border: "1px solid var(--border-purple)", borderRadius: "var(--radius-sm)" }}
          />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: "0.25rem", color: "var(--text-muted)", fontSize: "0.85rem" }}>
          Passwort
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            autoComplete={mode === "signin" ? "current-password" : "new-password"}
            style={{ padding: "0.5rem 0.75rem", background: "var(--bg-primary)", color: "var(--text-primary)", border: "1px solid var(--border-purple)", borderRadius: "var(--radius-sm)" }}
          />
        </label>
        {error && <div style={{ color: "#f87171", fontSize: "0.85rem" }}>{error}</div>}
        {info && <div style={{ color: "var(--accent-cyan)", fontSize: "0.85rem" }}>{info}</div>}
        <button
          type="submit"
          disabled={loading}
          style={{ padding: "0.6rem 1rem", background: "var(--accent-cyan)", color: "#0a0a14", border: "none", borderRadius: "var(--radius-sm)", fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}
        >
          {loading ? "..." : mode === "signin" ? "Einloggen" : "Account erstellen"}
        </button>
        <button
          type="button"
          onClick={() => { setMode(mode === "signin" ? "signup" : "signin"); setError(null); setInfo(null); }}
          style={{ background: "transparent", border: "none", color: "var(--text-muted)", fontSize: "0.85rem", cursor: "pointer" }}
        >
          {mode === "signin" ? "Noch kein Account? Sign Up" : "Schon ein Account? Login"}
        </button>
        <Link to="/" style={{ color: "var(--text-muted)", fontSize: "0.85rem", textAlign: "center", textDecoration: "none" }}>← Zurück zur Startseite</Link>
      </form>
    </div>
  );
}
